import { render } from "./ShowBoxesToClose.vue?vue&type=template&id=5c8ff1bf&scoped=true"
import script from "./ShowBoxesToClose.vue?vue&type=script&lang=js"
export * from "./ShowBoxesToClose.vue?vue&type=script&lang=js"

import "./ShowBoxesToClose.vue?vue&type=style&index=0&id=5c8ff1bf&scoped=true&lang=css"

import exportComponent from "D:\\Proyectos\\ERP ELECTRONICO\\ERP-FRONT\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c8ff1bf"]])

export default __exports__